// src/components/JSONLDPricing.tsx
"use client";

import { useEffect } from "react";

const JSONLDPricing = () => {
    useEffect(() => {
        const pricingSchema = {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Pricing - Mubarokah Digital Creative Agency",
            "description": "View the pricing list for our digital services at Mubarokah Digital Creative Agency. Find the package that fits your business needs and budget. We offer affordable and high-quality solutions for all types of projects.",
            "url": "https://mubarokah.com/pricing",
        };

        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.text = JSON.stringify(pricingSchema);
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, []);

    return null;
};

export default JSONLDPricing;
